import sectionsDefinition from './definitions/sectionsDefinition';
import * as categoriesDefinition from './definitions/categoriesDefinition';

export { sectionsDefinition, categoriesDefinition };
